
(function () {
    const style = document.createElement("style");
    style.textContent = `
        .npc-sidebar-price-box {
            position: sticky !important;
            bottom: 0 !important;
            transform: none !important;
        }
    `;
    document.head.appendChild(style);
})();

(function () {
    document.addEventListener("DOMContentLoaded", function () {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);
        if (params.has("variant")) {
            params.delete("variant");
            var newUrl = url.origin + url.pathname + "?" + params.toString();
            if (params.toString() === "") {
                newUrl = url.origin + url.pathname;
            }
            window.history.replaceState(null, null, newUrl);
        }
        setupTitleObserver();
    });
})();
function setupTitleObserver() {
    function addCustomLink() {
        const linkDiv = document.querySelector(
            ".npc-sidebar-container .npc-title.npc-selections-text-title",
        );
        if (
            linkDiv &&
            !document.getElementById("npc-selections-text-anchortag-link")
        ) {
            const anchorTag = document.createElement("a");
            anchorTag.href = " ";
            anchorTag.id = "npc-selections-text-anchortag-link";
            anchorTag.innerHTML = "Custom Logo / Design";
            anchorTag.addEventListener("click", (e) => {
                e.preventDefault();
                const neonCustomiserApp = document.getElementById(
                    "neon-customiser-app",
                );
                const customizerLeadForm = document.getElementById(
                    "customizer-lead-form",
                );
                if (neonCustomiserApp) {
                    neonCustomiserApp.style.display = "none";
                    customizerLeadForm.classList.remove("d-none");
                }
            });
            linkDiv.appendChild(anchorTag);
            document.querySelectorAll(".npc-preview-selector").forEach((e) => {
                (e.addEventListener("mouseenter", () => {
                    document.body.classList.add("hide-popper");
                }),
                    e.addEventListener("mouseleave", () => {
                        document.body.classList.remove("hide-popper");
                    }));
            });
        }
    }
    if (addCustomLink()) {
    } else {
        const titleObserver = new MutationObserver((mutations, obs) => {
            if (
                document.querySelector(
                    ".npc-sidebar-container .npc-title.npc-selections-text-title",
                )
            ) {
                if (addCustomLink()) {
                    obs.disconnect();
                }
            }
        });
        titleObserver.observe(document.body, { childList: !0, subtree: !0 });
        setTimeout(() => {
            if (addCustomLink()) {
                titleObserver.disconnect();
            }
        }, 1000);
        setTimeout(() => {
            if (addCustomLink()) {
                titleObserver.disconnect();
            }
        }, 3000);
    }
}
(function () {
    function initializeFeatures() {
        try {
            const linkDiv = document.querySelector(
                ".npc-sidebar-container .npc-title.npc-selections-text-title",
            );
            if (
                linkDiv &&
                !document.getElementById("npc-selections-text-anchortag-link")
            ) {
                const anchorTag = document.createElement("a");
                anchorTag.href = " ";
                anchorTag.id = "npc-selections-text-anchortag-link";
                anchorTag.innerHTML = "Custom Logo / Design";
                anchorTag.addEventListener("click", (e) => {
                    e.preventDefault();
                    const neonCustomiserApp = document.getElementById(
                        "neon-customiser-app",
                    );
                    const customizerLeadForm = document.getElementById(
                        "customizer-lead-form",
                    );
                    if (neonCustomiserApp) {
                        neonCustomiserApp.style.display = "none";
                        customizerLeadForm.classList.remove("d-none");
                    }
                });
                linkDiv.appendChild(anchorTag);
            }
            const doneButton = document.querySelector(
                ".template-page .main-content#MainContent .npc-sidebar-price-button-container .npc-sidebar-price-button.tw-bg-secondary",
            );
            const floatingButton = document.querySelector(
                "#floatingProductButton button",
            );
            const floatingButtonProductPrice = floatingButton?.querySelector(
                "#floatingButtonProductPrice",
            );
            const userTextarea = document.querySelector(
                "#neon-customiser-app .npc-selections-text-form textarea",
            );
            const productPrice = document?.querySelector(
                "#neon-customiser-app .npc-price.npc-sidebar-price span",
            );
            if (doneButton) {
                doneButton.addEventListener("click", () => { });
            }
            if (doneButton && doneButton.innerHTML == "Done") {
                doneButton.innerHTML = "<span> Buy Now </span>";
            }
            if (floatingButton) {
                floatingButton.disabled = !0;
                floatingButton.classList.add("disabled");
            }
            function updateFloatingPrice() {
                if (productPrice && floatingButtonProductPrice) {
                    floatingButtonProductPrice.innerHTML = productPrice.innerHTML;
                }
            }
            if (productPrice) {
                const observer = new MutationObserver(updateFloatingPrice);
                observer.observe(productPrice, { childList: !0, subtree: !0 });
            }
            if (doneButton && floatingButton && userTextarea) {
                const handleTextareaInput = (e) => {
                    let userInputValue = e.target.value.trim();
                    if (userInputValue.length >= 3) {
                        floatingButton.disabled = !1;
                        floatingButton.classList.remove("disabled");
                        updateFloatingPrice();
                        floatingButton.addEventListener(
                            "click",
                            () => {
                                doneButton.click();
                            },
                            { once: !0 },
                        );
                    } else {
                        floatingButton.disabled = !0;
                        floatingButton.classList.add("disabled");
                        floatingButtonProductPrice.innerHTML = "$0.00";
                    }
                };
                userTextarea.addEventListener("input", handleTextareaInput);
                if (window.matchMedia("(max-width: 768px)").matches) {
                    userTextarea.addEventListener("focus", () => {
                        setTimeout(() => {
                            document
                                .getElementById("HeaderWrapper")
                                .scrollIntoView({ behavior: "smooth", block: "center" });
                        }, 300);
                    });
                }
                userTextarea.dispatchEvent(new Event("input"));
            }
        } catch (error) {
            console.error("Error in initializeFeatures:", error);
        }
    }
    initializeFeatures();
    function checkElements() {
        const requiredSelectors = [
            ".template-page .main-content#MainContent .npc-sidebar-price-button-container .npc-sidebar-price-button.tw-bg-secondary",
            "#floatingProductButton button",
            "#neon-customiser-app .npc-selections-text-form textarea",
        ];
        return requiredSelectors.every((selector) =>
            document.querySelector(selector),
        );
    }
    const observerButtons = new MutationObserver((mutations, obs) => {
        if (checkElements()) {
            initializeFeatures();
            obs.disconnect();
        }
    });
    observerButtons.observe(document.body, { childList: !0, subtree: !0 });
    window.addEventListener("load", () => {
        if (checkElements()) {
            initializeFeatures();
            observerButtons.disconnect();
        } else {
            setTimeout(() => {
                if (checkElements()) {
                    initializeFeatures();
                    observerButtons.disconnect();
                } else {
                    setTimeout(() => {
                        if (checkElements()) {
                            initializeFeatures();
                        }
                        observerButtons.disconnect();
                    }, 5000);
                }
            }, 2000);
        }
    });
})();

((function () {
    // ── Config ──────────────────────────────────────────
    const CONFIG = {
        containerSel: '.npc-sidebar-container',
        headingSel: '.npc-heading',
        highlightWord: 'Creativity',      // change to any word
        paragraph: ' ',
        highlightClass: 'npc-highlight',
        paragraphClass: 'npc-tagline',
    };

    // ── Inject heading highlight + paragraph ─────────────
    function applyEnhancements(container) {
        const heading = container.querySelector(CONFIG.headingSel);
        if (!heading || heading.dataset.npcEnhanced) return;

        // 1. Wrap the target word in a <span>
        const regex = new RegExp(
            `(${CONFIG.highlightWord})`,
            'gi'
        );
        heading.innerHTML = heading.textContent.replace(
            regex,
            `<span class="${CONFIG.highlightClass}">$1</span>`
        );

        heading.classList.remove("lg:tw-mb-[18px]");
        heading.classList.replace("lg:tw-text-[24px]", "lg:tw-text-[45px]")

        // 2. Insert paragraph after heading
        const existing = container.querySelector(`.${CONFIG.paragraphClass}`);
        if (!existing) {
            const p = document.createElement('p');
            p.className = CONFIG.paragraphClass;
            p.textContent = CONFIG.paragraph;
            heading.insertAdjacentElement('afterend', p);
        }

        heading.dataset.npcEnhanced = 'true'; // idempotency guard
    }

    // ── Run on existing containers ───────────────────────
    document.querySelectorAll(CONFIG.containerSel).forEach(applyEnhancements);

    // ── Watch for containers added dynamically ────────────
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                // Direct match
                if (node.matches(CONFIG.containerSel)) {
                    applyEnhancements(node);
                }
                // Or a descendant container
                node.querySelectorAll(CONFIG.containerSel).forEach(applyEnhancements);
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

}))();

(function () {
    try {
        const safeLineLimitObserver = new MutationObserver(() => {
            try {
                const formParent = document.querySelector(".npc-selections-text-form");
                if (
                    formParent &&
                    !document.getElementById("line-limit-message-custom")
                ) {
                    const infoMessage = document.createElement("p");
                    infoMessage.id = "line-limit-message-custom";
                    infoMessage.textContent = "You can add up to 3 lines of Text.";
                    infoMessage.style.paddingLeft = "8px";
                    infoMessage.style.fontFamily = "var(--npc-font),sans-serif";
                    infoMessage.style.fontSize = ".75em";
                    infoMessage.style.color = "#ffffff";
                    formParent.appendChild(infoMessage);
                    const alignmentParent = document.querySelector(".npc-alignment");
                    if (alignmentParent && alignmentParent.children.length >= 2) {
                        alignmentParent.children[1].click();
                    }
                    const done_Button = document.querySelector(
                        ".template-page .main-content#MainContent .npc-sidebar-price-button-container .npc-sidebar-price-button",
                    );
                    const userTextarea = document.querySelector(
                        "#neon-customiser-app .npc-sidebar #npc-text-area",
                    );
                    done_Button.addEventListener("click", () => { });
                    if (window.matchMedia("(max-width: 768px)").matches) {
                        userTextarea.addEventListener("focus", () => {
                            setTimeout(() => {
                                const headerWrapper = document.getElementById("HeaderWrapper");
                                if (headerWrapper) {
                                    headerWrapper.scrollIntoView({
                                        behavior: "smooth",
                                        block: "center",
                                    });
                                }
                            }, 300);
                        });
                    }
                    safeLineLimitObserver.disconnect();
                }
            } catch (innerError) {
                console.error(
                    "[LineLimitInjectionError]: Failed to inject line limit message.",
                    innerError,
                );
            }
        });
        safeLineLimitObserver.observe(document.body, {
            childList: !0,
            subtree: !0,
        });
    } catch (outerError) {
        console.error(
            "[LineLimitObserverError]: Failed to set up MutationObserver.",
            outerError,
        );
    }
})();
function prosemirrorDetector() {
    const prosemirrorTargetNode = document.body;
    const prosemirrorConfig = {
        attributes: !0,
        subtree: !0,
        attributeFilter: ["class"],
    };
    const prosemirrorCallback = function (prosemirrorMutationsList) {
        for (const prosemirrorMutation of prosemirrorMutationsList) {
            if (prosemirrorMutation.type === "attributes") {
                const prosemirrorTarget = prosemirrorMutation.target;
                if (prosemirrorTarget.classList.contains("ProseMirror-focused")) {
                    if (window.matchMedia("(max-width: 768px)").matches) {
                        setTimeout(() => {
                            const headerWrapper = document.getElementById("HeaderWrapper");
                            if (headerWrapper) {
                                headerWrapper.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                });
                            }
                        }, 300);
                    }
                }
            }
        }
    };
    const prosemirrorObserver = new MutationObserver(prosemirrorCallback);
    prosemirrorObserver.observe(prosemirrorTargetNode, prosemirrorConfig);
    return prosemirrorObserver;
}
const prosemirrorObserverInstance = prosemirrorDetector();

document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector("#neon-customiser-app");
    if (!section) return;

    let chatbotStored = null;
    let originalParent = null;

    // --- Throttle helper ---
    function throttle(func, limit) {
        let inThrottle;
        return function () {
            if (!inThrottle) {
                func.apply(this, arguments);
                inThrottle = true;
                setTimeout(() => (inThrottle = false), limit);
            }
        };
    }

    // --- Scroll logic ---
    const checkScroll = () => {
        if (!chatbotStored) return;

        const rect = section.getBoundingClientRect();
        const sectionBottom = rect.bottom;

        // Trigger when bottom of section reaches 90% of viewport height
        const passed90 = sectionBottom <= window.innerHeight * 0.8;

        if (passed90) {
            // ✅ Show chatbot
            if (!document.body.contains(chatbotStored)) {
                (originalParent || document.body).appendChild(chatbotStored);
            }
        } else {
            // ❌ Hide chatbot
            if (document.body.contains(chatbotStored)) {
                chatbotStored.remove();
            }
        }
    };

    const throttledCheck = throttle(checkScroll, 150);

    // --- Slider fill logic ---
    const sliderSelector = ".npc-selections-slider-input";
    const initialisedSliders = new WeakSet();

    const updateSliderFill = (slider) => {
        const min = +slider.min || 0;
        const max = +slider.max || 100;
        const value = +slider.value;
        const pct = max === min ? 0 : ((value - min) / (max - min)) * 100;
        slider.style.setProperty("--slider-fill-percent", `${pct}%`);
    };

    const initSlider = (slider) => {
        if (initialisedSliders.has(slider)) return;
        initialisedSliders.add(slider);

        updateSliderFill(slider);
        slider.addEventListener("input", () => updateSliderFill(slider));
        // 'change' covers programmatic value updates that dispatch a change event
        slider.addEventListener("change", () => updateSliderFill(slider));
    };

    // Initialise any sliders already in the DOM
    document.querySelectorAll(sliderSelector).forEach(initSlider);

    // --- MutationObserver: chatbot + sliders ---
    // We keep observing for sliders since the customiser may re-render them,
    // but stop watching for the chatbot once we've grabbed it.
    let chatbotFound = false;

    const domObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return; // element nodes only

                // Chatbot detection
                if (
                    !chatbotFound &&
                    node.matches &&
                    node.matches("inbox-online-store-chat#ShopifyChat")
                ) {
                    chatbotStored = node;
                    originalParent = node.parentNode || document.body;
                    node.remove();
                    checkScroll();
                    chatbotFound = true;
                }

                // Slider detection — the node itself…
                if (node.matches && node.matches(sliderSelector)) {
                    initSlider(node);
                }
                // …or sliders nested inside the added subtree
                if (node.querySelectorAll) {
                    node.querySelectorAll(sliderSelector).forEach(initSlider);
                }
            });
        });
    });

    domObserver.observe(document.body, { childList: true, subtree: true });

    // --- Scroll + resize handlers ---
    window.addEventListener("scroll", throttledCheck);
    window.addEventListener("resize", throttledCheck);
});

/// Global object to store submission data
window.klaviyoFormSubmission = {};

// Debouncing variables
let klaviyoEmailDebounceTimer = null;
let klaviyoTextDebounceTimer = null;
const KLAVIYO_DEBOUNCE_DELAY = 1000;

// Store previous values to detect actual changes
let klaviyoPreviousValues = {};

function klaviyoHasDataChanged(key, newValue) {
    const previousValue = klaviyoPreviousValues[key];
    const hasChanged = previousValue !== newValue;

    if (hasChanged) {
        klaviyoPreviousValues[key] = newValue;
    }

    return hasChanged;
}

function klaviyoSaveData(key, value, source = "input") {
    if (!value) return false;

    // Check if the value has actually changed
    if (!klaviyoHasDataChanged(key, value)) {
        console.log(`[KlaviyoAPI] No change detected for ${key}, skipping save`);
        return false;
    }

    window.klaviyoFormSubmission = {
        ...window.klaviyoFormSubmission,
        [key]: value,
        klaviyoLastUpdated: new Date().toISOString(),
        klaviyoSource: source,
    };

    localStorage.setItem(
        "klaviyoFormSubmission",
        JSON.stringify(window.klaviyoFormSubmission),
    );
    console.log(`[KlaviyoAPI] Data updated for ${key}:`, value);
    return true;
}

function klaviyoSendDataToAPI(reason = "auto") {
    const klaviyoData = JSON.parse(
        localStorage.getItem("klaviyoFormSubmission") || "{}",
    );
    if (!klaviyoData.klaviyoEmail) {
        console.log("[KlaviyoAPI] No email found, skipping API call");
        return;
    }

    const isUpdate = klaviyoData.recordId ? true : false;
    const endpoint = isUpdate
        ? `https://copy-lead.marke-ter.online/api/update/${klaviyoData.recordId}`
        : "https://copy-lead.marke-ter.online/api/capture";

    const method = isUpdate ? "PUT" : "POST";

    console.log(`[KlaviyoAPI] Sending ${method} request for reason: ${reason}`);

    fetch(endpoint, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            ...klaviyoData,
            klaviyoEvent: reason,
        }),
        keepalive: true,
    })
        .then((response) => response.json())
        .then((data) => {
            if (!isUpdate && data.status === "success" && data.recordId) {
                window.klaviyoFormSubmission.recordId = data.recordId;
                localStorage.setItem(
                    "klaviyoFormSubmission",
                    JSON.stringify(window.klaviyoFormSubmission),
                );
            }
            console.log(
                `[KlaviyoAPI] ${isUpdate ? "Update" : "Create"} successful:`,
                data,
            );
        })
        .catch((err) =>
            console.error(
                `[KlaviyoAPI] ${isUpdate ? "Update" : "Create"} failed:`,
                err,
            ),
        );
}

// ---------------- Email ----------------
function klaviyoAttachEmailListeners(klaviyoForm) {
    const klaviyoEmailInput = klaviyoForm.querySelector('input[name="email"]');
    if (!klaviyoEmailInput) return;

    klaviyoEmailInput.addEventListener("input", function () {
        const emailValue = klaviyoEmailInput.value.trim();
        const dataChanged = klaviyoSaveData(
            "klaviyoEmail",
            emailValue,
            "email-typing",
        );

        if (klaviyoEmailDebounceTimer) clearTimeout(klaviyoEmailDebounceTimer);

        // Only set timer if data actually changed and email is valid
        if (dataChanged && emailValue) {
            klaviyoEmailDebounceTimer = setTimeout(() => {
                klaviyoSendDataToAPI("email-input");
            }, KLAVIYO_DEBOUNCE_DELAY);
        }
    });

    klaviyoEmailInput.addEventListener("blur", function () {
        const emailValue = klaviyoEmailInput.value.trim();
        if (emailValue && klaviyoEmailDebounceTimer) {
            clearTimeout(klaviyoEmailDebounceTimer);
            klaviyoEmailDebounceTimer = null;
            klaviyoSendDataToAPI("email-blur");
        }
    });
}

// ---------------- Text Box ----------------
function klaviyoAttachTextBoxListeners(klaviyoEditableDiv) {
    function klaviyoGetText() {
        return klaviyoEditableDiv.innerText.trim();
    }

    klaviyoEditableDiv.addEventListener("input", () => {
        const textValue = klaviyoGetText();
        const dataChanged = klaviyoSaveData(
            "klaviyoUserText",
            textValue,
            "textbox-input",
        );

        if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
            if (klaviyoTextDebounceTimer) clearTimeout(klaviyoTextDebounceTimer);
            klaviyoTextDebounceTimer = setTimeout(() => {
                klaviyoSendDataToAPI("textbox-input");
            }, KLAVIYO_DEBOUNCE_DELAY);
        }
    });

    klaviyoEditableDiv.addEventListener("blur", () => {
        if (
            window.klaviyoFormSubmission?.klaviyoEmail &&
            klaviyoTextDebounceTimer
        ) {
            clearTimeout(klaviyoTextDebounceTimer);
            klaviyoTextDebounceTimer = null;
            klaviyoSendDataToAPI("textbox-blur");
        }
    });
}

// ---------------- Size ----------------
function klaviyoAttachSizeListeners(sizeContainer) {
    const sizeButtons = sizeContainer.querySelectorAll(".npc-selection-button");
    sizeButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const label =
                btn.querySelector(".npc-selection-button-title")?.innerText.trim() ||
                "";
            const dataChanged = klaviyoSaveData("klaviyoSize", label, "size-select");

            if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
                klaviyoSendDataToAPI("size-select");
            }
        });
    });
}

// ---------------- Material ----------------
function klaviyoAttachMaterialListeners(materialContainer) {
    const materialButtons = materialContainer.querySelectorAll(
        ".npc-selection-button",
    );
    materialButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const label =
                btn.querySelector(".npc-selection-button-title")?.innerText.trim() ||
                "";
            const dataChanged = klaviyoSaveData(
                "klaviyoMaterial",
                label,
                "material-select",
            );

            if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
                klaviyoSendDataToAPI("material-select");
            }
        });
    });
}

// ---------------- Backboard ----------------
function klaviyoAttachBackboardListeners(backboardContainer) {
    const backboardButtons = backboardContainer.querySelectorAll(
        ".npc-selection-button",
    );
    backboardButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const label =
                btn.querySelector(".npc-selection-button-title")?.innerText.trim() ||
                "";
            const dataChanged = klaviyoSaveData(
                "klaviyoBackboard",
                label,
                "backboard-select",
            );

            if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
                klaviyoSendDataToAPI("backboard-select");
            }
        });
    });
}

// ---------------- Jacket ----------------
function klaviyoAttachJacketListeners(jacketContainer) {
    const jacketButtons = jacketContainer.querySelectorAll(
        ".npc-selection-button",
    );
    jacketButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const titleEl = btn.querySelector(".npc-selection-button-title");
            const subtitleEl = btn.querySelector(".npc-selection-button-subtitle");

            const jacketLabel = titleEl ? titleEl.innerText.trim() : "";
            const jacketValue = subtitleEl ? subtitleEl.innerText.trim() : "";

            const labelChanged = klaviyoSaveData(
                "klaviyoJacket",
                jacketLabel,
                "jacket-select",
            );
            const valueChanged = klaviyoSaveData(
                "klaviyoJacketValue",
                jacketValue,
                "jacket-select",
            );

            if (
                (labelChanged || valueChanged) &&
                window.klaviyoFormSubmission?.klaviyoEmail
            ) {
                klaviyoSendDataToAPI("jacket-select");
            }
        });
    });
}

// ---------------- Backboard Color ----------------
function klaviyoAttachBackboardColorListeners(backboardColorContainer) {
    const colorButtons = backboardColorContainer.querySelectorAll(
        ".npc-preview-selector",
    );

    colorButtons.forEach((btn, idx) => {
        btn.addEventListener("click", () => {
            // Extract image URL from the span's background
            const bgStyle = btn.querySelector("span")?.getAttribute("style") || "";
            const imageUrlMatch = bgStyle.match(/url\(["']?(.*?)["']?\)/);
            const colorImageUrl = imageUrlMatch ? imageUrlMatch[1] : "";

            // Extract color name from the example div
            const labelEl = backboardColorContainer.querySelector(
                ".tw-flex.tw-text-left",
            );
            const colorName = labelEl
                ? labelEl.textContent.trim()
                : `Option ${idx + 1}`;

            // Save the selection
            klaviyoSaveData(
                "klaviyoBackboardColor",
                colorName,
                "backboard-color-select",
            );
            klaviyoSaveData(
                "klaviyoBackboardColorImage",
                colorImageUrl,
                "backboard-color-select",
            );

            // Send update if email exists
            if (window.klaviyoFormSubmission?.klaviyoEmail) {
                klaviyoSendDataToAPI("backboard-color-select");
            }
        });
    });
}

// ---------------- Color ----------------
function klaviyoAttachColorListeners(colorContainer) {
    const colorButtons = colorContainer.querySelectorAll(".npc-preview-selector");

    colorButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const span = btn.querySelector("span");
            if (!span) return;

            // Get color value from inline style
            const colorStyle = span.getAttribute("style") || "";
            const colorValue = colorStyle
                .replace("background:", "")
                .trim()
                .replace(";", "");

            // Also try to capture a label if available (e.g. "Hot Pink")
            const labelEl = colorContainer.querySelector(
                ".tw-flex.tw-text-left.tw-font-bold",
            );
            const colorLabel = labelEl ? labelEl.innerText.trim() : colorValue;

            // Save color selection
            const labelChanged = klaviyoSaveData(
                "klaviyoColor",
                colorLabel,
                "color-select",
            );
            const valueChanged = klaviyoSaveData(
                "klaviyoColorValue",
                colorValue,
                "color-select",
            );

            // Send update only if email already exists and data changed
            if (
                (labelChanged || valueChanged) &&
                window.klaviyoFormSubmission?.klaviyoEmail
            ) {
                klaviyoSendDataToAPI("color-select");
            }
        });
    });
}

// ---------------- Font ----------------
function klaviyoAttachFontListeners(fontContainer) {
    const fontButtons = fontContainer.querySelectorAll(".npc-font-button");

    fontButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const span = btn.querySelector("span[data-font]");
            if (!span) return;

            const fontKey = span.getAttribute("data-font");
            const fontName = span.innerText.trim();

            // Save font selection
            const nameChanged = klaviyoSaveData(
                "klaviyoFont",
                fontName,
                "font-select",
            );
            const keyChanged = klaviyoSaveData(
                "klaviyoFontKey",
                fontKey,
                "font-select",
            );

            // Send update only if email already exists and data changed
            if (
                (nameChanged || keyChanged) &&
                window.klaviyoFormSubmission?.klaviyoEmail
            ) {
                klaviyoSendDataToAPI("font-select");
            }
        });
    });
}

// ---------------- Initialize Previous Values ----------------
function klaviyoInitializePreviousValues() {
    const existingData = localStorage.getItem("klaviyoFormSubmission");
    if (existingData) {
        window.klaviyoFormSubmission = JSON.parse(existingData);

        // Initialize previous values with existing data
        Object.keys(window.klaviyoFormSubmission).forEach((key) => {
            klaviyoPreviousValues[key] = window.klaviyoFormSubmission[key];
        });

        console.log(
            "[KlaviyoAPI] Initialized with existing data:",
            klaviyoPreviousValues,
        );
    }
}

// ---------------- MutationObserver ----------------
const klaviyoDOMObserver = new MutationObserver((klaviyoMutations) => {
    klaviyoMutations.forEach((klaviyoMutation) => {
        klaviyoMutation.addedNodes.forEach((klaviyoNode) => {
            if (klaviyoNode.nodeType === 1) {
                // Email form
                const klaviyoForm =
                    klaviyoNode.querySelector?.('[data-testid="klaviyo-form-RyyyMM"]') ||
                    (klaviyoNode.matches?.('[data-testid="klaviyo-form-RyyyMM"]')
                        ? klaviyoNode
                        : null);
                if (klaviyoForm) klaviyoAttachEmailListeners(klaviyoForm);

                // Text editor
                const klaviyoEditableDiv =
                    klaviyoNode.querySelector?.(".tiptap.ProseMirror") ||
                    (klaviyoNode.matches?.(".tiptap.ProseMirror") ? klaviyoNode : null);
                if (klaviyoEditableDiv)
                    klaviyoAttachTextBoxListeners(klaviyoEditableDiv);

                // Color selection
                const colorContainer =
                    klaviyoNode.querySelector?.(".npc-selections-color") ||
                    (klaviyoNode.matches?.(".npc-selections-color") ? klaviyoNode : null);
                if (colorContainer) klaviyoAttachColorListeners(colorContainer);

                // Font selection
                const fontContainer =
                    klaviyoNode.querySelector?.(".npc-selections-font-list") ||
                    (klaviyoNode.matches?.(".npc-selections-font-list")
                        ? klaviyoNode
                        : null);
                if (fontContainer) klaviyoAttachFontListeners(fontContainer);

                // Size
                const sizeContainer =
                    klaviyoNode.querySelector?.(".npc-selections-size") ||
                    (klaviyoNode.matches?.(".npc-selections-size") ? klaviyoNode : null);
                if (sizeContainer) klaviyoAttachSizeListeners(sizeContainer);

                // Material
                const materialContainer =
                    klaviyoNode.querySelector?.(".npc-selections-material") ||
                    (klaviyoNode.matches?.(".npc-selections-material")
                        ? klaviyoNode
                        : null);
                if (materialContainer)
                    klaviyoAttachMaterialListeners(materialContainer);

                // Backboard
                const backboardContainer =
                    klaviyoNode.querySelector?.(".npc-selections-backboard") ||
                    (klaviyoNode.matches?.(".npc-selections-backboard")
                        ? klaviyoNode
                        : null);
                if (backboardContainer)
                    klaviyoAttachBackboardListeners(backboardContainer);

                // Jacket
                const jacketContainer =
                    klaviyoNode.querySelector?.(".npc-selections-jacket") ||
                    (klaviyoNode.matches?.(".npc-selections-jacket")
                        ? klaviyoNode
                        : null);
                if (jacketContainer) klaviyoAttachJacketListeners(jacketContainer);

                // Backboard Color
                const backboardColorContainer =
                    klaviyoNode.querySelector?.(".npc-selections-backboard-color") ||
                    (klaviyoNode.matches?.(".npc-selections-backboard-color")
                        ? klaviyoNode
                        : null);
                if (backboardColorContainer)
                    klaviyoAttachBackboardColorListeners(backboardColorContainer);
            }
        });
    });
});

// ---------------- Init ----------------
klaviyoInitializePreviousValues();
klaviyoDOMObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", () => {
    // --- URL guard: only run on the custom neon signs page ---
    if (window.location.pathname !== "/pages/updated-custom-neon-signs") return;

    const buttonSelector = ".npc-font-button .fit-text-fonts";
    const editorSelector = "#npc-text-area .tiptap";

    let editor = null;
    const initialisedEditors = new WeakSet();

    // --- Read current text from the contenteditable ---
    const getEditorText = (el) => {
        return (el.textContent || "").trim();
    };

    // --- Update every font-preview button to show the given text ---
    const updateButtonText = (text) => {
        const buttons = document.querySelectorAll(buttonSelector);
        buttons.forEach((span) => {
            if (!span.dataset.originalText) {
                span.dataset.originalText = span.textContent;
            }
            span.textContent = text || span.dataset.originalText;
        });
    };

    // --- Wire up a tiptap editor once it appears ---
    const initEditor = (el) => {
        if (initialisedEditors.has(el)) return;
        initialisedEditors.add(el);
        editor = el;

        const initial = getEditorText(el);
        if (initial) updateButtonText(initial);

        const editorObserver = new MutationObserver(() => {
            updateButtonText(getEditorText(el));
        });

        editorObserver.observe(el, {
            childList: true,
            subtree: true,
            characterData: true,
        });

        el.addEventListener("input", () => {
            updateButtonText(getEditorText(el));
        });
    };

    const existing = document.querySelector(editorSelector);
    if (existing) initEditor(existing);

    const domObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return;

                if (node.matches && node.matches(editorSelector)) {
                    initEditor(node);
                }
                if (node.querySelector) {
                    const nested = node.querySelector(editorSelector);
                    if (nested) initEditor(nested);
                }
            });
        });
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener("DOMContentLoaded", () => {
    // --- URL guard: only run on the custom neon signs page ---
    // if (window.location.pathname !== "/pages/updated-custom-neon-signs") return;

    const buttonSelector = ".npc-font-button .fit-text-fonts";
    const editorSelector = "#npc-text-area .tiptap";

    let editor = null;
    const initialisedEditors = new WeakSet();

    // --- Read current text from the contenteditable ---
    const getEditorText = (el) => {
        return (el.textContent || "").trim();
    };

    // --- Update every font-preview button to show the given text ---
    const updateButtonText = (text) => {
        const buttons = document.querySelectorAll(buttonSelector);
        buttons.forEach((span) => {
            if (!span.dataset.originalText) {
                span.dataset.originalText = span.textContent;
            }
            span.textContent = text || span.dataset.originalText;
        });
    };

    // --- Wire up a tiptap editor once it appears ---
    const initEditor = (el) => {
        if (initialisedEditors.has(el)) return;
        initialisedEditors.add(el);
        editor = el;

        const initial = getEditorText(el);
        if (initial) updateButtonText(initial);

        const editorObserver = new MutationObserver(() => {
            updateButtonText(getEditorText(el));
        });

        editorObserver.observe(el, {
            childList: true,
            subtree: true,
            characterData: true,
        });

        el.addEventListener("input", () => {
            updateButtonText(getEditorText(el));
        });
    };

    const existing = document.querySelector(editorSelector);
    if (existing) initEditor(existing);

    const domObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return;

                if (node.matches && node.matches(editorSelector)) {
                    initEditor(node);
                }
                if (node.querySelector) {
                    const nested = node.querySelector(editorSelector);
                    if (nested) initEditor(nested);
                }
            });
        });
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
});

// (function () {
//   var MOBILE_QUERY = '(max-width: 768px)';
//   var CONTAINER_SELECTOR = '.npc-selections-font-list, .npc-selections-letter-part-color-previews';
//   var PROCESSED_ATTR = 'data-npc-swipe-ready';

//   function isMobile() {
//     return window.matchMedia(MOBILE_QUERY).matches;
//   }

//   function arrowSVG(dir) {
//     var d = dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
//     return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
//            '<path d="' + d + '" stroke="currentColor" stroke-width="2.2" ' +
//            'stroke-linecap="round" stroke-linejoin="round"/></svg>';
//   }

//   function makeArrow(dir) {
//     var btn = document.createElement('button');
//     btn.type = 'button';
//     btn.className = 'npc-swipe-arrow npc-swipe-' + dir;
//     btn.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
//     btn.innerHTML = arrowSVG(dir);
//     return btn;
//   }

//   function enhance(container) {
//     if (container.hasAttribute(PROCESSED_ATTR)) return;

//     var list = container.querySelector('.npc-list');
//     if (!list) return;

//     container.setAttribute(PROCESSED_ATTR, 'true');

//     var prev = makeArrow('prev');
//     var next = makeArrow('next');
//     container.appendChild(prev);
//     container.appendChild(next);

//     function update() {
//       var max = list.scrollWidth - list.clientWidth;
//       prev.classList.toggle('is-disabled', list.scrollLeft <= 2);
//       next.classList.toggle('is-disabled', list.scrollLeft >= max - 2);
//     }

//     function page(dir) {
//       list.scrollBy({ left: list.clientWidth * 0.8 * dir, behavior: 'smooth' });
//     }

//     prev.addEventListener('click', function () { page(-1); });
//     next.addEventListener('click', function () { page(1); });
//     list.addEventListener('scroll', update, { passive: true });
//     window.addEventListener('resize', update);

//     update();
//   }

//   function teardown(container) {
//     if (!container.hasAttribute(PROCESSED_ATTR)) return;
//     container.removeAttribute(PROCESSED_ATTR);
//     var arrows = container.querySelectorAll('.npc-swipe-arrow');
//     for (var i = 0; i < arrows.length; i++) arrows[i].remove();
//   }

//   function scan(root) {
//     if (!isMobile()) return;
//     var containers;
//     if (root.matches && root.matches(CONTAINER_SELECTOR)) {
//       containers = [root];
//     } else if (root.querySelectorAll) {
//       containers = Array.prototype.slice.call(root.querySelectorAll(CONTAINER_SELECTOR));
//     } else {
//       containers = [];
//     }
//     containers.forEach(enhance);
//   }

//   function syncAllWithViewport() {
//     var all = document.querySelectorAll(CONTAINER_SELECTOR);
//     for (var i = 0; i < all.length; i++) {
//       if (isMobile()) enhance(all[i]);
//       else teardown(all[i]);
//     }
//   }

//   // Initial pass in case the containers already exist when this script runs.
//   scan(document.body);

//   // Watch for the containers being rendered later (SPA route change, AJAX, etc).
//   var observer = new MutationObserver(function (mutations) {
//     for (var m = 0; m < mutations.length; m++) {
//       var added = mutations[m].addedNodes;
//       for (var n = 0; n < added.length; n++) {
//         var node = added[n];
//         if (node.nodeType === 1) scan(node); // element nodes only
//       }
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

//   // Add/remove arrows when the viewport crosses the mobile breakpoint.
//   var mq = window.matchMedia(MOBILE_QUERY);
//   if (mq.addEventListener) {
//     mq.addEventListener('change', syncAllWithViewport);
//   } else if (mq.addListener) {
//     mq.addListener(syncAllWithViewport); // older Safari
//   }
// })();